import React from 'react';
import { Box } from '@wix/design-system';
export const StackedMobileCard = _ref => {
  let badges = _ref.badges,
    title = _ref.title,
    bullets = _ref.bullets,
    pricing = _ref.pricing,
    cta = _ref.cta,
    _ref$spacious = _ref.spacious,
    spacious = _ref$spacious === void 0 ? false : _ref$spacious;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "20px 16px",
    gap: spacious ? '36px' : '16px',
    flex: 1
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: spacious ? '24px' : '16px',
    minWidth: 0
  }, badges, title), bullets, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: spacious ? '32px' : '16px',
    marginTop: "auto"
  }, pricing, cta));
};
//# sourceMappingURL=StackedMobileCard.js.map